module.exports = __webpack_public_path__ + "static/media/total_campaign.f5c21a1f.svg";